export const FETCH_ARCHIEVE_CONVERSATION_REQUEST = "FETCH_ARCHIEVE_CONVERSATION_REQUEST";
export const FETCH_ARCHIEVE_CONVERSATION_SUCCESS = "FETCH_ARCHIEVE_CONVERSATION_SUCCESS";
export const FETCH_ARCHIEVE_CONVERSATION_FAILURE = "FETCH_ARCHIEVE_CONVERSATION_FAILURE";

export const FETCH_RECENT_CONVERSATION_REQUEST = "FETCH_RECENT_CONVERSATION_REQUEST";
export const FETCH_RECENT_CONVERSATION_SUCCESS = "FETCH_RECENT_CONVERSATION_SUCCESS";
export const FETCH_RECENT_CONVERSATION_FAILURE = "FETCH_RECENT_CONVERSATION_FAILURE";

export const MARK_RECENT_CONVERSATION_AS_ARCHIEVE_REQUEST = 'MARK_RECENT_CONVERSATION_AS_ARCHIEVE_REQUEST';
export const MARK_RECENT_CONVERSATION_AS_ARCHIEVE_SUCCESS = 'MARK_RECENT_CONVERSATION_AS_ARCHIEVE_SUCCESS';
export const MARK_RECENT_CONVERSATION_AS_ARCHIEVE_FAILURE = 'MARK_RECENT_CONVERSATION_AS_ARCHIEVE_FAILURE';

export const MARK_ARCHIEVE_CONVERSATION_AS_RECENT_REQUEST = 'MARK_ARCHIEVE_CONVERSATION_AS_RECENT_REQUEST';
export const MARK_ARCHIEVE_CONVERSATION_AS_RECENT_SUCCESS = 'MARK_ARCHIEVE_CONVERSATION_AS_RECENT_SUCCESS';
export const MARK_ARCHIEVE_CONVERSATION_AS_RECENT_FAILURE = 'MARK_ARCHIEVE_CONVERSATION_AS_RECENT_FAILURE';

export const ADD_RECENT_CONVERSATION_STATE = "ADD_RECENT_CONVERSATION_STATE";

export const UPDATE_CONVERSATION_TITLE_REQUEST = 'UPDATE_CONVERSATION_TITLE_REQUEST';
export const UPDATE_RECENT_CONVERSATION_TITLE_SUCCESS = 'UPDATE_RECENT_CONVERSATION_TITLE_SUCCESS';
export const UPDATE_ARCHIEVE_CONVERSATION_TITLE_SUCCESS = 'UPDATE_ARCHIEVE_CONVERSATION_TITLE_SUCCESS';
export const UPDATE_CONVERSATION_TITLE_FAILURE = 'UPDATE_CONVERSATION_TITLE_FAILURE';

export const UPDATE_CONVERSATION_UPDATEDDATE = 'UPDATE_CONVERSATION_UPDATEDDATE';

export const UPDATE_RECENT_CONVERSATION_IF_NOT_AVAILABLE = 'UPDATE_RECENT_CONVERSATION_IF_NOT_AVAILABLE';

